<!--  -->
<template>
  <el-container class="ResourceManageContainer easyCruds">
    <el-aside width="21.25rem" class="ResourceManage ">
        <el-card shadow="never" class="box-card" body-style="padding:0px;" style="height:95%;">
            <div slot="header" class="ResourceManage_head" >
               <i  class="fa fa-sitemap ResourceManage_icon" />
              <span class="ResourceManage_title"> 资源树 </span>
              <el-button style="float:right" @click="reset" size="mini" type="primary"> 重置</el-button>
            </div>
            <!-- 搜索区域 -->
            <div class="ResourceManage_Search">
              <el-row>
                <el-col :offset="1" :span="5">
                  <div class="ResourceManage_Search_text">所属应用</div>
                </el-col>
                <el-col :offset="1" :span="15">
                  <el-select size="mini" @change="appKeyChange" v-model="appKey" style="width:100%" placeholder="请选择所属应用">
                       <el-option v-for="(item,index) in appKeyOptions" :key="index" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-col >
              </el-row>
              <el-row>
                <el-col :offset="1" :span="5">
                  <div class="ResourceManage_Search_text">搜索模式</div>
                </el-col>
                <el-col :offset="1" :span="15">
                  <el-select @change="searchPatternChange"  v-model="searchPattern"  style="width:100%"  size="mini" placeholder="请选择搜索模式">
                     <el-option label="区域搜索" :value="true"></el-option>
                     <el-option label="全局搜索" :value="false"></el-option>
                  </el-select>
                </el-col >
              </el-row>
            </div>
            <div class="tree" v-loading="!searchPattern" element-loading-text="禁用"  element-loading-spinner="fa fa-ban">
              <el-tree  ref="mainTree" node-key="id"  lazy :load="loadMainTreeNode"
                @current-change="currentNodeChange"
                :highlight-current='true'
                :expand-on-click-node="false"
                :render-content="renderContent">
              </el-tree>
            </div>
          </el-card>
    </el-aside>
    <el-main>
      <easyCruds ref="mainTable" :tableInfo="mainTable"
      @mainTableReload="mainTableReload"
      @beforeAddRow="beforeAddRow"
      @beforeEditRow="beforeEditRow"
      @deleteRows="deleteRows"
      @addOrEditRow="addOrEditRow"
      @concatPublicTheme="concatPublicTheme"
      @concatPrimaryTheme="concatPrimaryTheme"
      >
      <template slot-scope="{easyFormInfo,disabled,data,label,prop}" slot="objForm">
            <el-input :disabled="disabled" placeholder="请输入对象" v-model="data[prop]" class="input-with-select">
              <template v-if="data.objSwitch" slot="prepend">{{data.objPrepend}}</template>
              <el-switch v-model="data.objSwitch" :disabled="disabled" slot="append" >

              </el-switch>
          </el-input>
      </template>
      <localTable ref="extTable" :data="extTable.data"  :allowModify="extTable.allowModify" slot="formSlot"  />
      <template slot="pidForm"   slot-scope="{easyFormInfo,disabled,data,label,prop}" >
        <resourceSelector v-if="easyFormInfo.header.show" @change="pidChange(data)" :appKey="appKey"  v-model="data[prop]" :disabled="disabled" />
      </template>
      </easyCruds>
    </el-main>
     <!-- 资源关联公有主题 -->
     <concatPrimaryTheme ref="concatPrimaryTheme"  :isShow="concatTheme.PrimaryShow" :optionRow="concatTheme.optionRow"></concatPrimaryTheme>
     <!-- 关联公有主题 -->
     <concatPublicTheme ref="concatPublicTheme" :isShow="concatTheme.PublicShow" :optionRow="concatTheme.optionRow" ></concatPublicTheme>
  </el-container>
</template>

<script>
import { RESOURSE_CONFIG } from '@/page/config/base_config'

export default {
  data() {
    return {
      /** 搜索模式控制 */
      searchPattern: true,
      /** appKey 控制 */
      appKey: null,
      appKeyOptions: [],
      /** 资源树控制 */
      loadNodeMap: new Map(),
      /** 当前选中的节点 */
      currentTableNode: null,
      /** 控制扩展字段表,插入的插槽位置 */
      extTable: {
        data: [],
        allowModify: false
      },
      concatTheme: {
        optionRow: {},
        PrimaryShow: {
          show: false
        },
        PublicShow: {
          show: false
        }
      },
      mainTable: {
        header: { title: '资源管理' },
        buttonSetting: {
          allowAdd: true,
          addText: '新增资源',
          addCloseOnClickModal: true,
          beforeAddFunctionName: 'beforeAddRow',
          addButtonArray: [{
            clickEvent: 'addOrEditRow',
            type: 'primary',
            buttonName: '新增',
            validate: true
          }],
          allowEdit: true,
          editText: '编辑资源',
          editCloseOnClickModal: true,
          beforeEditFunctionName: 'beforeEditRow',
          editButtonArray: [{
            clickEvent: 'addOrEditRow',
            type: 'primary',
            buttonName: '保存编辑',
            validate: true
          }],
          allowDelete: true,
          deleteFunctionName: 'deleteRows',
          allowView: true,
          viewText: '查看资源',
          viewCloseOnClickModal: true,
          beforeViewFunctionName: 'beforeEditRow',
          left: [{
            title: '关联私有主题',
            type: 'primary',
            icon: 'el-icon-sort-up',
            clickEvent: 'concatPrimaryTheme'
          }, {
            title: '关联公有主题',
            type: 'success',
            icon: 'el-icon-sort-up',
            clickEvent: 'concatPublicTheme'
          }]
        },
        table: {
          search_xl: 8,
          search_lg: 12,
          search_md: 24,
          search_sm: 24,
          loading: false,
          height: 535,
          stripe: true,
          conditionLabelWidth: 'auto',
          selection: true,
          columns: [{
            prop: 'pid',
            label: '上级资源id',
            showInTable: false,
            type: 'input',
            span: 12,
            'placeholder': '无上级资源',
            formslot: true,
            disabled: [false, true, false]
          }, {
            prop: 'resourceStatus',
            label: '状态',
            width: 100,
            type: 'select',
            isSearchCondition: true,
            isTag: true,
            dicData: [{
              'label': '可用',
              'value': 1
            }, {
              'label': '不可用',
              'value': 2
            }],
            required: true,
            tagFilter: function(columnData) {
              if (columnData === 1) {
                return { data: '可用', type: 'success' }
              } else {
                return { data: '不可用', type: 'warning' }
              }
            }
          }, {
            prop: 'obj',
            formslot: true,
            label: '对象',
            span: 24,
            isSearchCondition: true,
            type: 'input',
            align: 'left',
            'maxlength': 500,
            required: true
          }, {
            prop: 'description',
            label: '描述',
            rows: 5,
            span: 24,
            type: 'textarea',
            isSearchCondition: true,
            required: true
          }, {
            prop: 'act',
            label: '访问动作',
            width: 150,
            type: 'input',
            'maxlength': 500,
            required: true
          }, {
            prop: 'accessCondition',
            label: '访问条件',
            width: 150,
            isSearchCondition: true,
            type: 'input'
          }, {
            prop: 'resourceType',
            label: '类型',
            sortable: false,
            width: 100,
            isTag: true,
            isSearchCondition: true,
            type: 'select',
            dicData: [{
              label: '数据',
              value: 'DATA'
            }, {
              label: '接口',
              value: 'API'
            }, {
              label: '界面元素',
              value: 'UI'
            }, {
              label: '其他',
              value: 'OTHER'
            }],
            tagFilter: function(columnData) {
              if (columnData === 'DATA') {
                return { data: '数据' }
              } else if (columnData === 'API') {
                return { data: '接口' }
              } else if (columnData === 'UI') {
                return { data: '界面元素' }
              } else {
                return { data: '其他' }
              }
            },
            required: true
          },
          {
            prop: 'sort',
            label: '排序',
            type: 'number',
            width: 100,
            // showInTable: false,
            'controlsPosition': '',
            'minRows': 0,
            'maxRows': 100
          }],
          operation: {
            width: 150,
            operations: []
          },
          paging: {
            currentPage: 1,
            pageSizes: [15, 20, 25, 30],
            pageSize: 15,
            total: 0
          },
          tableData: [],
          reload: 'mainTableReload',
          reloadConditions: { },
          addDefultValue: { }
        }}

    }
  },
  components: {
    localTable: () => import('@/framework/components/view/localTable/localTable.vue'),
    concatPrimaryTheme: () => import('../resourceManage/internalComponents/concatPrimaryTheme/concatPrimaryTheme'),
    concatPublicTheme: () => import('../resourceManage/internalComponents/concatPublicTheme/concatPublicTheme'),
    resourceSelector: () => import('../resourceManage/internalComponents/resourceSelector/resourceSelector')
  },
  mounted: function() {
    /** 获取所属应用 select 加载选项 */
    this.getSelectOPtion()
  },

  methods: {
    reset: function() {
      let data = this.loadNodeMap.get('root')
      if (data) {
        this.reLoadMainTreeNode(data.node, data.resolve)
        this.currentNodeChange(null, data.node)
      }
    },
    searchPatternChange: function() {
      this.mainTable.header.title = '资源控制'
      this.mainTable.table.tableData = []
      this.mainTable.table.paging.total = 0
      if (this.searchPattern) {
        // 局部搜索
        if (this.currentTableNode) {
          this.currentNodeChange(null, this.currentTableNode)
        }
      } else {
        // 全局搜索
        this.mainTableReload(Object.assign(this.$refs.mainTable.getReloadConditions(), { pageNum: 1 }))
      }
    },
    /**
     * 选择的树节点改变时,触发该函数
     */
    currentNodeChange: function(data, node) {
      this.mainTable.header.title = node.data.description
      this.currentTableNode = node
      this.$nextTick(() => {
        this.mainTableReload(Object.assign(this.$refs.mainTable.getReloadConditions(), { pageNum: 1 }))
      })
    },
    /** 当主表需要重载的时候 */
    mainTableReload: function(params) {
      if (!this.appKey) return this.$message.warning('appKey 丢失,请刷新页面后再尝试')
      if (!this.currentTableNode && this.searchPattern) return this.$message.warning('当前选中节点 丢失,请刷新页面后再尝试')
      this.mainTable.table.loading = true
      this.$http.post('/resource/query', { 'entity': {
        'obj': params.obj,
        'resourceType': params.resourceType,
        'accessCondition': params.accessCondition,
        'description': params.description,
        'resourceStatus': params.resourceStatus,
        'appKey': this.appKey,
        'pid': !this.searchPattern ? null : this.currentTableNode.data.id === 'root' ? '' : this.currentTableNode.data.id
      }, 'orderItemList': [{
        'asc': true,
        'column': 'sort' }] }, { params: {
        'pageNum': params.pageNum || 1,
        'pageSize': params.pageSize || 15
      }}).then(response => {
        this.mainTable.table.loading = false
        this.mainTable.table.tableData = response.data.records
        this.mainTable.table.paging.total = response.data.total || response.data.records.length
      }).catch(error => {
        this.mainTable.table.loading = false
        this.$message.error(error.msg || error.message)
      })
    },
    /**
     * 树节点展示 render 函数
     */
    renderContent(h, { data }) {
      return (
        <span style='display: flex; flex: 1; align-items: center; justify-content: space-between; font-size: 0.625rem; padding-right: 8px;0.5rem;'>
          {data.description}
        </span>
      )
    },
    appKeyChange: function() {
      let data = this.loadNodeMap.get('root')
      if (data) {
        this.reLoadMainTreeNode(data.node, data.resolve)
        this.currentNodeChange(null, data.node)
      }
    },
    reLoadMainTreeNode: function(node, resolve) {
      node.childNodes = []
      this.loadMainTreeNode(node, resolve)
    },
    loadMainTreeNode: function(node, resolve) {
      if (!node.data) {
        node.data = { id: 'root', description: '资源控制' }
      }
      this.loadNodeMap.set(node.data.id, { node, resolve })
      if (!this.appKey) return
      this.$http.post('/resource/list', { 'entity': {
        'appKey': this.appKey,
        'pid': node.data.id === 'root' ? (RESOURSE_CONFIG.RESOURSE_ROOT_ID === undefined ? '' : RESOURSE_CONFIG.RESOURSE_ROOT_ID) : node.data.id
      }, 'orderItemList': [{
        'asc': true,
        'column': 'sort' }] }).then(response => {
        node.childNodes = []
        return resolve(response.data)
      }).catch(error => {
        node.childNodes = []
        resolve([])
        this.$message.error(error.msg || error.message)
      })
    },
    /** 获取所属应用 */
    getSelectOPtion: function() {
      this.$http.post('/resource/list-authorized-resource', { entity: {
        'obj': 'Permission.App',
        'appKey': '@PUBLIC'
      }},
      { params: { isRecursive: true, recursiveWithCondition: true, recursiveIgnoreProperties: ['obj'], onlyChild: true }}).then(response => {
        let result = []
        response.data.forEach(element => {
          let temp = {}
          element.resourceExtList.forEach(item => {
            if (item.extPropertyKey === 'appName') {
              temp.label = item.extPropertyValue
            } else if (item.extPropertyKey === 'appKey') {
              temp.value = item.extPropertyValue
            }
          })
          result.push(temp)
        })
        this.appKeyOptions = result
        if (result.length !== 0) {
          this.appKey = result[0].value
          this.appKeyChange()
        }
      }).catch(error => {
        this.$message.error(error.msg || error.message)
      })
    },

    /**
     * 设置扩展字段插槽名称,并控制按钮
     */
    setExtTable: function name(data = [], type) {
      this.extTable.data.splice(0, this.extTable.data.length)
      data.forEach(item => this.extTable.data.push(item))
      if (type === 'VIEW') {
        this.extTable.allowModify = false
      } else {
        this.extTable.allowModify = true
      }
      return true
    },
    beforeAddRow: function(NULL, optionType, call) {
      if (!this.appKey) {
        return this.$message.error('请选择所属应用后再进行操作')
      }
      this.setExtTable([], 'ADD')
      if (this.searchPattern && this.currentTableNode &&
       this.currentTableNode.data && this.currentTableNode.data.id && this.currentTableNode.data.id !== 'root') {
        /** 局部搜索模式下 且有上级id */
        let objPrepend = this.currentTableNode.data.obj
        if (objPrepend.lastIndexOf('/') !== objPrepend.length - 1) {
          objPrepend += '/'
        }
        call({ appKey: this.appKey, pid: this.currentTableNode.data, objPrepend, objSwitch: true })
      } else {
        call({ appKey: this.appKey, objSwitch: false, objPrepend: '' })
      }
    },
    /** Execute this function before opening the view Windows or edit Windows */
    beforeEditRow: function(row, optionType, callback) {
      this.mainTable.table.loading = true
      /** Control expanded field dataTables add, delete button state */
      this.$http.get('/resource/' + row.id).then(response => {
        this.mainTable.table.loading = false
        this.setExtTable(response.data.resourceExtList, optionType)
        if (row.pid) {
          this.$http.get(`/resource/${row.pid}`).then(response => {
            row.pid = response.data
            let objPrepend = this.currentTableNode.data.obj
            if (objPrepend.lastIndexOf('/') !== objPrepend.length - 1) {
              objPrepend += '/'
            }
            row.objPrepend = objPrepend
            if (row.obj && row.obj.indexOf(objPrepend) !== -1) {
              row.objSwitch = true
            } else {
              row.objSwitch = false
            }
            if (row.objSwitch) {
              row.obj = row.obj.replace(row.objPrepend, '')
            }
            callback(row)
          }).catch(error => {
            this.$message.error(error.msg || error.message)
          })
        } else {
          callback()
        }
      }).catch(error => {
        this.mainTable.table.loading = false
        return this.$message.error(error.msg || error.message)
      })
    },
    /** 删除数据 */
    deleteRows: function(deleteList) {
      this.mainTable.table.loading = true
      this.$http.post('/resource/delete', deleteList.map(item => { return { 'id': item.id, 'appKey': item.appKey } })).then(response => {
        this.mainTable.table.loading = false
        this.$message.success('删除成功！')
        this.$refs.mainTable.reload()
        if (this.currentTableNode) {
          let data = this.loadNodeMap.get((this.currentTableNode.data.id))
          if (data) {
            this.reLoadMainTreeNode(data.node, data.resolve)
          }
        }
      }).catch(error => {
        this.mainTable.table.loading = false
        this.$message.error(error.msg || error.message)
      })
    },
    /**
     * 新增或编辑资源
     */
    addOrEditRow: function(row, done, errorDone, optionType, setting, oldData) {
      if (!(row.pid || (row.pid && !row.pid.id))) {
        row.pid = ''
      } else {
        row.pid = row.pid.id
      }
      row.resourceExtList = this.extTable.data
      if (row.objSwitch) {
        row.obj = row.objPrepend + row.obj
      }
      this.$http[optionType === 'EDIT' ? 'put' : 'post']('/resource', [row]).then(response => {
        if (optionType === 'EDIT') {
          this.$message.success('资源修改成功！') && done()
          this.$refs.mainTable.reload()
          if (row.pid !== oldData.pid.id) {
            let data = this.loadNodeMap.get(oldData.pid === '' ? 'root' : row.pid)
            if (data) {
              this.reLoadMainTreeNode(data.node, data.resolve)
            }
          }
          let datas = this.loadNodeMap.get(row.pid === '' ? 'root' : row.pid)
          if (datas) {
            this.reLoadMainTreeNode(datas.node, datas.resolve)
          }
        } else {
          this.$message.success('资源添加成功！') && done()
          let pid = row.pid === '' ? 'root' : row.pid
          let data = this.loadNodeMap.get(pid)
          if (data) {
            this.reLoadMainTreeNode(data.node, data.resolve)
          }
        }
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
      }).catch(error => {
        this.$message.error(error.msg || error.message) && errorDone()
      })
    },

    // ///////////////////////////////////////////////////////////////////
    //
    //  下面是管理资源相关的函数代码，操作独立的组件
    //
    // //////////////////////////////////////////////////////////////////
    /**
     * 关联私有主题
     */
    concatPrimaryTheme: function(index, row) {
      let optionRow = this.getOptionRow(index, row)
      if (optionRow !== false) {
        this.concatTheme.optionRow = optionRow
        this.concatTheme.PrimaryShow.show = true
        this.$refs.concatPrimaryTheme.Initialize()
      }
    },
    /**
     * 关联公有主题
     */
    concatPublicTheme: function(index, row) {
      let optionRow = this.getOptionRow(index, row)
      if (optionRow !== false) {
        this.concatTheme.optionRow = optionRow
        this.concatTheme.PublicShow.show = true
        this.$refs.concatPublicTheme.Initialize()
      }
    },
    /** *
     * 获取操作列辅助函数
     */
    getOptionRow: function(index, row) {
      let optionRow = []
      if (row) {
        optionRow = optionRow.push(this.deepClone(row))
      } else {
        optionRow = this.$refs.mainTable.getSelectedRows()
        if (optionRow.length === 0) {
          this.$message({ message: '请选中一条记录再操作哟。', type: 'warning' })
          return false
        } else if (optionRow.length >= 2) {
          this.$message({ message: '只能选择一行记录进行操作哟', type: 'warning' })
          return false
        }
        optionRow = this.deepClone(optionRow)
      }
      return optionRow[0]
    },
    pidChange: function(data) {
      if (data.pid) {
        this.$http.get(`/resource/${data.pid.id}`).then(response => {
          let objPrepend = response.data.obj
          if (objPrepend.lastIndexOf('/') !== objPrepend.length - 1) {
            objPrepend += '/'
          }
          data.objPrepend = objPrepend
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      } else {
        data.objSwitch = false
        data.objPrepend = ''
      }
    }

  }
}

</script>

<style lang='scss' scoped>
.ResourceManageContainer{
  padding: 0 15px;
}

.ResourceManage {
    &_head {
        &_icon {
            color: #409EFF
        }
        &_title {
            text-indent: 2px;
            color: #409EFF;
        }
        text-indent:2px;
        color:#409EFF;
    }
    &_Search{
      margin-top: 0.625rem;
      &_text{
        color: #409EFF;
        font-size: 0.9375rem;
        line-height: 1.75rem;
        text-align: center;
      }
    }
}
.tree {
    overflow-y:scroll;
    overflow-x: scroll;
    height: 44.375rem;
}
</style>

